// extracted by mini-css-extract-plugin
module.exports = {"container":"recoverPassword_container__2FYxT","button":"recoverPassword_button__1v6Sq"};